module.exports = __webpack_public_path__ + "img/unconstellations-art.322415fe.png";